/********************************
Glider for timeline - render glider first
********************************/
const timelineGlide = new Glide('.timeline-glide', {
  type: 'slider',
  perView: 3,
  gap: 0,
  animationDuration: 500,
  autoplay: false,
  rewind: false,
  dragThreshold: 60,
  breakpoints: {
    767: {
      perView: 1,
    }
  }
});

timelineGlide.mount();

/********************************
After adjusting layouts
Set timeline container height
********************************/
// const timelineContainer = document.getElementById("timeline-container");
const timelineSlides = document.querySelector(".timeline-slides");
const timelineGlideSlides= document.getElementById("timeline-glide-slides");
const timelineGrid = document.getElementById("timeline-grid");
const milestones = timelineGrid.querySelectorAll(".milestone");

// create descendantHeights array
const descendantHeights = []
for (let i = 0; i < milestones.length; i++) {
  let descendantList = milestones[i].querySelector(".milestone-descendant-list");
  if (descendantList != null) {
    let descendantY = descendantList.offsetTop;
    let descendantHeight = descendantList.offsetHeight;

    // console.log(descendantList, descendantY, descendantHeight);
    descendantHeights.push(descendantY + descendantHeight);
  }
}
// get the largest descendant height from the array
const mostDescendantHeight = Math.max.apply(Math, descendantHeights);
// get the timelineSlides Y position
const timelineSlidesY = timelineSlides.offsetTop;
// change the height of timeline slide container
timelineGlideSlides.style.height = (mostDescendantHeight + timelineSlidesY) + "px";

/********************************
 * Glide elements style changes apply
 * when sliders move
********************************/
const trackLine = document.getElementById("track-line");
const trackLineBottom = document.getElementById("track-line-bottom");
const nextButton = document.querySelector(".glider-navigation .next--top");
const nextButtonBottom = document.querySelector(".glider-navigation .next--bottom");
const thirdLastSlide = timelineGlideSlides.querySelector(".glide__slide:nth-last-child(3)");
const secondLastSlide = timelineGlideSlides.querySelector(".glide__slide:nth-last-child(2)");
const lastSlide = timelineGlideSlides.querySelector(".timeline-slides:last-child");
const allPhaseSlides = timelineGlideSlides.querySelectorAll(".timeline-year-phase");
const allJumpLinks = document.querySelectorAll(".timeline-jumplink");
const timelineGlideTrack = document.getElementById("timeline-glide-track");
const timelineGlideTrackXpos = timelineGlideTrack.offsetLeft;
const milestoneContentSlides = document.querySelectorAll(".milestone-content-slide");

// match trackline width with glide slides width
trackLine.style.width = timelineGlideSlides.offsetWidth + "px";
trackLineBottom.style.width = timelineGlideSlides.offsetWidth + "px";

// when glideSlider style attribute changes
var observer = new MutationObserver(function(el) {
  trackChange();

  setTimeout(function(){
    milestoneContentSlideXPos();
    buttonChange();
    jumplinkChange();
  }, 500);
});
// when glideSlider style attribute changes
observer.observe(timelineGlideSlides, { attributes : true, attributeFilter : ['style'] });

// when jumplink click re-adjust sticky milestone content
document.addEventListener("click", function(event) {
  if (event.target.matches(".timeline-jumplink")) {
    for (let i = 0; i < milestoneContentSlides.length; i++) {
      milestoneContentSlides[i].style.marginLeft = 0 + "px";
    }
  }
});

// change trackLine style when glides
function trackChange() {
  let trackStyles = timelineGlideSlides.style;
  for (const prop in trackStyles) {
    if (
      Object.hasOwn(trackStyles, prop) &&
      !Number.isNaN(Number.parseInt(prop))
    ) {
      trackLine.setAttribute('style', trackStyles.cssText);
      trackLine.style.height = "4px";
      trackLineBottom.setAttribute('style', trackStyles.cssText);
      trackLineBottom.style.height = "4px";
    }
  }
}

// sticky longer milestone content
function milestoneContentSlideXPos() {
  for (let i = 0; i < milestoneContentSlides.length; i++) {
    let $this = milestoneContentSlides[i];
    let elContainer = $this.closest(".milestone");
    let rect = elContainer.getBoundingClientRect();
    let elContainerXpos = parseInt(rect.left + window.scrollX, 10);
    let elContainerWidth = elContainer.offsetWidth;
    let elXpos = parseInt(timelineGlideTrackXpos - elContainerXpos, 10);

    if (elContainerXpos <= timelineGlideTrackXpos && (elXpos + $this.offsetWidth) < elContainerWidth) {
      $this.style.marginLeft = parseInt(timelineGlideTrackXpos - elContainerXpos, 10) + "px";
    }

    // console.log(i + ": ", elContainerXpos, timelineGlideTrackXpos, elXpos, $this.offsetWidth, elContainerWidth);
  }
}

// disable next button when reaching the end of the slides
function buttonChange() {
  if (window.innerWidth > 767) {
    if (thirdLastSlide.classList.contains("glide__slide--active") || secondLastSlide.classList.contains("glide__slide--active") || lastSlide.classList.contains("glide__slide--active")) {
      nextButton.classList.add("disabled");
      nextButtonBottom.classList.add("disabled");
    }
    else {
      nextButton.classList.remove("disabled");
      nextButtonBottom.classList.remove("disabled");
    }
  }
}

// change jump links style
function jumplinkChange() {
  for (let i = 0; i < allJumpLinks.length; i++) {
    allJumpLinks[i].classList.remove("disabled");
  }

  for (let i = 0; i < allPhaseSlides.length; i++) {
    if (allPhaseSlides[i].classList.contains("glide__slide--active")) {
      let matchingJumplink = document.querySelector(".timeline-jumplink--" + i);

      if (matchingJumplink != null) {
        matchingJumplink.classList.add("disabled");
      }
    }
  }
}

/********************************
 * Pop ups
 * show/hide
********************************/
const main = document.querySelector("main");
const popUps = document.getElementById("pop-ups");
const popUpsOverlay = document.getElementById("pop-ups-overlay");
const popUpButtons = document.querySelectorAll(".pop-up-button");
const popUpWindows = document.querySelectorAll(".pop-up");
const popUpCloseButtons = document.querySelectorAll(".pop-up-close");

let lastFocusedElement = null;
let activeTrapListener = null;

// Open modal
popUpButtons.forEach((button) => {
  const popUpId = button.dataset.entryId;
  const popUpWindow = document.getElementById("pop-up--" + popUpId);

  button.addEventListener("click", () => {
    lastFocusedElement = document.activeElement;

    main.setAttribute("aria-hidden", "true");
    popUps.classList.add("active");
    popUpWindow.classList.add("active");
    popUpWindow.setAttribute("aria-hidden", "false");

    // Inject ARIA roles
    popUpWindow.setAttribute("role", "dialog");
    popUpWindow.setAttribute("aria-modal", "true");

    // Find the first heading and use as aria-labelledby
    const heading = popUpWindow.querySelector("h1, h2, h3, h4, h5, h6");
    if (heading) {
      if (!heading.id) {
        heading.id = `modal-heading-${Math.floor(Math.random() * 100000)}`;
      }
      popUpWindow.setAttribute("aria-labelledby", heading.id);
    }

    const focusable = getFocusableElements(popUpWindow)[0];
    if (focusable) focusable.focus();

    // Trap focus
    activeTrapListener = (e) => trapFocus(e, popUpWindow);
    document.addEventListener("keydown", activeTrapListener);
  });
});

// Close modal (button or overlay)
[...popUpCloseButtons, popUpsOverlay].forEach((el) => {
  el.addEventListener("click", () => {
    closeAllPopUps();
  });
});

function closeAllPopUps() {
  main.removeAttribute("aria-hidden");
  popUps.classList.remove("active");

  popUpWindows.forEach((win) => {
    win.classList.remove("active");
    win.setAttribute("aria-hidden", "true");

    // Remove ARIA attributes
    win.removeAttribute("role");
    win.removeAttribute("aria-modal");
    win.removeAttribute("aria-labelledby");
  });

  if (lastFocusedElement) lastFocusedElement.focus();
  if (activeTrapListener) {
    document.removeEventListener("keydown", activeTrapListener);
    activeTrapListener = null;
  }
}

function trapFocus(e, container) {
  if (e.key !== "Tab") return;

  const focusable = getFocusableElements(container);
  if (focusable.length === 0) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (e.shiftKey) {
    if (document.activeElement === first) {
      e.preventDefault();
      last.focus();
    }
  } else {
    if (document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
}

function getFocusableElements(container) {
  return [...container.querySelectorAll(
    'a[href], button:not([disabled]), textarea, input:not([disabled]), select, [tabindex]:not([tabindex="-1"])'
  )].filter(el => !el.hasAttribute("disabled") && el.offsetParent !== null);
}